import { FC } from 'react'

import { DARK_GREY_COLOR } from '../../utils/constants'

interface CheckCircleIconProps {
  color?: string
  width?: number
  height?: number
  className?: string
}

const CheckCircleIcon: FC<CheckCircleIconProps> = ({ color = DARK_GREY_COLOR, width = 24, height = 24, className = '' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill="white"
    />
    <path
      d="M18.1982 8.14102C18.3742 7.96034 18.6681 7.9522 18.8545 8.12285C19.0202 8.27453 19.0453 8.51642 18.9251 8.6952L18.8733 8.75898L10.9804 16.859C10.8148 17.0289 10.5476 17.0449 10.3628 16.9091L10.2978 16.851L6.11919 12.351C5.94765 12.1663 5.96311 11.8818 6.1537 11.7155C6.32312 11.5677 6.57389 11.5631 6.748 11.6937L6.80939 11.749L10.6503 15.8858L18.1982 8.14102Z"
      fill={color}
      stroke="#86DA07"
      strokeWidth="1.28571"
    />
  </svg>
)

export default CheckCircleIcon
